import React from 'react';

function PrivacyPolicy() {
  return (
    <div className="page policy-page">
      <section className="page-hero">
        <div className="container">
          <div className="page-hero-content">
            <span className="page-badge">Legal</span>
            <h1>Privacy Policy</h1>
            <p>Last updated: April 2026</p>
          </div>
        </div>
      </section>

      <section className="page-content">
        <div className="container">
          <div className="policy-content">
            <h2>1. Introduction</h2>
            <p>
              SlotsHub UK ("we", "us", or "our") is committed to protecting your privacy. This Privacy Policy 
              explains how we collect, use, disclose, and safeguard your information when you visit our website 
              slotshubuk.com (the "Site").
            </p>
            <p>
              Please read this privacy policy carefully. If you do not agree with the terms of this privacy 
              policy, please do not access the Site.
            </p>

            <h2>2. Information We Collect</h2>
            <h3>Information You Provide</h3>
            <p>We may collect information that you voluntarily provide when you:</p>
            <ul>
              <li>Contact us through our contact form</li>
              <li>Subscribe to our newsletter (if applicable)</li>
              <li>Participate in surveys or promotions</li>
            </ul>
            <p>This information may include your name, email address, and any other information you choose to provide.</p>

            <h3>Automatically Collected Information</h3>
            <p>When you visit our Site, we may automatically collect certain information about your device, including:</p>
            <ul>
              <li>IP address</li>
              <li>Browser type and version</li>
              <li>Operating system</li>
              <li>Pages visited and time spent on those pages</li>
              <li>Referring website addresses</li>
              <li>Other diagnostic data</li>
            </ul>

            <h2>3. Cookies and Tracking Technologies</h2>
            <p>
              We use cookies and similar tracking technologies to track activity on our Site and hold certain information. 
              Cookies are small data files stored on your device. We use:
            </p>
            <ul>
              <li><strong>Essential cookies:</strong> Required for the Site to function properly</li>
              <li><strong>Analytics cookies:</strong> Help us understand how visitors interact with our Site</li>
              <li><strong>Marketing cookies:</strong> Used to track visitors across websites for advertising purposes</li>
            </ul>
            <p>
              You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. 
              However, if you do not accept cookies, you may not be able to use some portions of our Site.
            </p>
            <p>For more information about our use of cookies, please see our Cookie Policy.</p>

            <h2>4. How We Use Your Information</h2>
            <p>We may use the information we collect for various purposes, including to:</p>
            <ul>
              <li>Provide, maintain, and improve our Site</li>
              <li>Respond to your comments, questions, and requests</li>
              <li>Send you technical notices and support messages</li>
              <li>Monitor and analyse trends, usage, and activities</li>
              <li>Detect, investigate, and prevent fraudulent transactions and other illegal activities</li>
              <li>Personalise and improve your experience</li>
              <li>Comply with legal obligations</li>
            </ul>

            <h2>5. Disclosure of Your Information</h2>
            <p>We may share your information in the following situations:</p>
            <ul>
              <li><strong>With service providers:</strong> We may share information with third-party vendors who perform services on our behalf, such as hosting, analytics, and email delivery</li>
              <li><strong>For legal purposes:</strong> We may disclose information if required by law or in response to valid requests by public authorities</li>
              <li><strong>Business transfers:</strong> Information may be transferred in connection with a merger, acquisition, or sale of assets</li>
              <li><strong>With your consent:</strong> We may disclose your information for any other purpose with your consent</li>
            </ul>

            <h2>6. Affiliate Links</h2>
            <p>
              Our Site contains links to third-party websites, including online casinos. When you click on an affiliate 
              link and visit a casino website, that website may collect information about you. We are not responsible 
              for the privacy practices of these third-party websites. We encourage you to read the privacy policies 
              of any website you visit.
            </p>

            <h2>7. Data Security</h2>
            <p>
              We use appropriate technical and organisational measures to protect the information we collect. However, 
              no method of transmission over the Internet or electronic storage is 100% secure. While we strive to 
              protect your personal information, we cannot guarantee its absolute security.
            </p>

            <h2>8. Your Rights Under UK GDPR</h2>
            <p>Under the UK General Data Protection Regulation (UK GDPR), you have the following rights:</p>
            <ul>
              <li><strong>Right of access:</strong> You can request copies of your personal data</li>
              <li><strong>Right to rectification:</strong> You can request correction of inaccurate data</li>
              <li><strong>Right to erasure:</strong> You can request deletion of your data in certain circumstances</li>
              <li><strong>Right to restrict processing:</strong> You can request limitation of data processing</li>
              <li><strong>Right to data portability:</strong> You can request transfer of your data</li>
              <li><strong>Right to object:</strong> You can object to certain types of processing</li>
            </ul>
            <p>To exercise any of these rights, please contact us using the details provided below.</p>

            <h2>9. Children's Privacy</h2>
            <p>
              Our Site is not intended for children under 18 years of age. We do not knowingly collect personal 
              information from children under 18. If we learn we have collected personal information from a child 
              under 18, we will delete that information as quickly as possible.
            </p>

            <h2>10. Changes to This Privacy Policy</h2>
            <p>
              We may update our Privacy Policy from time to time. We will notify you of any changes by posting the 
              new Privacy Policy on this page and updating the "Last updated" date. We encourage you to review this 
              Privacy Policy periodically for any changes.
            </p>

            <h2>11. Contact Us</h2>
            <p>If you have any questions about this Privacy Policy, please contact us at:</p>
            <p>
              <strong>Email:</strong> privacy@slotshubuk.com<br />
              <strong>Website:</strong> slotshubuk.com/contact
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default PrivacyPolicy;
